import cn from 'classnames';
import type React from 'react';
import { Controller, type Control } from 'react-hook-form';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton } from '@mui/material';
import * as st from './styles.module.scss';

interface Props {
  name: string;
  control: Control<any>;
  disabled?: boolean;
  error: boolean;
  label: string;
  setValue?: () => void;
  showPassword?: boolean | undefined;
  autoComplete?: boolean;
  onChange?: () => void;
}

const PasswordControlled: React.FC<Props> = ({
  name,
  control,
  label,
  error,
  showPassword,
  disabled,
  setValue,
  autoComplete = true,
  onChange: onInputChanges,
}) => {
  // console.log('autoComplete:', autoComplete);
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value = '', name } }) => {
        return (
          <>
            <label className={cn(st.label, error && st.error)} htmlFor={name}>
              <p>{label}</p>
            </label>
            <div className={cn(st.controller, error && st.error)}>
              <div className={cn(st.wrapper__input, error && st.error)}>
                <input
                  id={name}
                  type={showPassword || !autoComplete ? 'text' : 'password'}
                  value={value}
                  onChange={(e) => {
                    onInputChanges && onInputChanges();
                    onChange(e);
                  }}
                  disabled={disabled}
                  className={cn(st.input, !showPassword && st.withTextSecurity)}
                  name={name}
                  autoComplete={autoComplete ? 'on' : 'off'}
                />
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={setValue}
                  onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault()}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </div>
            </div>
          </>
        );
      }}
      control={control}
    />
  );
};

export default PasswordControlled;
